// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.error-message[data-v-99f9e336] {\n  font-size: 25px;\n  margin-top: 10rem;\n  text-align: center;\n}\n.max-width[data-v-99f9e336] {\n  margin-top: 3rem;\n  width: 60vw\n}\n.welcome[data-v-99f9e336] {\n font-size: 20px;\n font-weight: 700;\n}\n", ""]);
// Exports
module.exports = exports;
